/* eslint-disable no-unused-vars */
import axios from '@/axios'

export default {
  async getOrderAcptDtlNo() {
    return new Promise((resolve, reject) => {
      axios.get('/order/acceptance-detail-number').then(
        (response) =>
          resolve({
            acptDtlNo: '220218003344'
          }),
        (error) =>
          resolve({
            acptDtlNo: '220218003344'
          })
      )
    })
  },
  async cancelOrder(data) {
    let acptNo = null
    if (data.acptNo) {
      acptNo = data.acptNo
      delete data.acptNo
    }
    return new Promise((resolve, reject) => {
      axios.put(`/order/${acptNo}/domestic-stay-cancel`, data).then(
        (res) => {
          resolve({
            transactionId: '',
            acptINo: '',
            cancelNo: ''
          })
        },
        (error) => {
          resolve({
            transactionId: '',
            acptINo: '',
            cancelNo: ''
          })
        }
      )
    })
  },
  async getCanclePolicy(acptNo) {
    return new Promise((resolve, reject) => {
      axios.get(`/order/cancel-policy/${acptNo}`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async orderLowPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/order/low-price', data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getOrderPulbicStayParam(menuNo) {
    // const headers = {
    //   'Content-Type': 'application/json'
    // }

    return new Promise((resolve, reject) => {
      axios.get(`menu/${menuNo}/orders/public-inn/stay-param`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async createOrderPulbicStay(data) {
    return new Promise((resolve, reject) => {
      axios.post('orders/public-stay', data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async sendAddingUserEmail(acptNo, data) {
    return new Promise((resolve, reject) => {
      axios.post(`order/${acptNo}/companion-info`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getSubsidyPublicStay(menuNo) {
    return new Promise((resolve, reject) => {
      axios.post(`/menu/${menuNo}/orders/public-inn/stay-param`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async getPublicStayGuide(acptNo, data) {
    return new Promise((resolve, reject) => {
      axios.post(`/orders/${acptNo}/public-stay/guide`, data).then(
        (res) => {
          // resolve(res.data)
          resolve({
            userGuidanceKey: 'string',
            pdfFilePath: 'string'
          })
        },
        (error) => {
          // reject(error?.error)
          resolve({
            userGuidanceKey: 'string',
            pdfFilePath: 'string'
          })
        }
      )
    })
  },
  async checkOrderTour(data) {
    return new Promise((resolve, reject) => {
      axios.post(`/v1/dp/order`, data).then(
        (res) => {
          const data = {
            status: 200
          }
          resolve(data.status)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getOrderInfoPublicStay(acptNo) {
    const mockData = {
      orderPublicStayDetail: {
        acpt: {
          acptNo: '220414007297',
          linkAcptNo: '2200007281',
          acptDatetime: '2022-04-14 13:46:34',
          acptStaffId: '90000002',
          totalAmt: 0,
          billAmtTotal: 0,
          boneBillAmtTotal: 0,
          pstg: 0,
          billAmtTotalPstgIn: 0,
          boneBillAmtTotalPstgIn: 0,
          pointUseNumAmt: 0,
          pointGrntNumAmt: 0,
          aplySbsidAmt: 0,
          aplyCafePointAmt: 0,
          setlSts: '10',
          userAgent: 'Java/11.0.14.1',
          pointUseCd: null,
          acptRouteDiv: null
        },
        customer: {
          customerNo: '449924000000001',
          familyName: 'Viet',
          firstName: 'Nam',
          familyNameKana: null,
          firstNameKana: null,
          birthday: null,
          sex: null,
          email: 'kyubi95@exdonuts.com',
          tel: '07035174967',
          postalCode: '1670022',
          prefectureCode: '13',
          address1: '東京都千代田区霞が関霞が関ビル（１８階）',
          address2: '霞が関霞が関ビル（１８階）',
          addrNm: 'ベネ　太郎',
          company: null,
          dept: null,
          courseId: '49199406',
          companyCd: 'C100070CC',
          subscriptionId: '202160',
          priceDiv: '10',
          addressDiv: '1',
          telDiv: '1',
          tel2: '0344059539',
          telDiv2: '2',
          faxDiv: null,
          fax: null
        },
        acptDtlList: [
          {
            acptDtl: {
              acptDtlNo: '220414007788',
              blshSysCd: null,
              cafePointAplyFlag: '0',
              cancelDatetime: null,
              cancelNo: null,
              cancelStaffId: null,
              chngDatetime: null,
              chngStaffId: null,
              dtlSts: '5',
              dtlStsChngDatetime: '2022-04-14 13:46:34',
              linkAcptDtlNo: '2200006902',
              linkCancelNo: null,
              menuNo: '10560107',
              orderPatternDiv: null,
              payMethod: null,
              payeeDiv: null,
              planId: null,
              pointAplyFlag: '0',
              pointExchangeSts: null,
              pyrlDedDiv: null,
              resrvReqstOutptFlag: '0',
              sbsidAplyFlag: '0',
              srvicDiv: null,
              travelBranchNo: 0,
              usageDiv: null,
              useDate: '2022-04-14',
              useHeadCnt: 10,
              rsvReqPaperAutoSendFlag: '0',
              ccOperatorHandleFlag: '0',
              shippingFlag: '0',
              usageLimitNotCountFlag: '0'
            },
            acptDtlStsManageList: [
              {
                stsDiv: '101',
                sts: '0',
                stsChngDatetime: '2022-04-14 13:46:34'
              },
              {
                stsDiv: '102',
                sts: '9',
                stsChngDatetime: '2022-04-14 13:46:34'
              },
              {
                stsDiv: '103',
                sts: '0',
                stsChngDatetime: '2022-04-14 13:46:34'
              },
              {
                stsDiv: '104',
                sts: '9',
                stsChngDatetime: '2022-04-14 13:46:34'
              },
              {
                stsDiv: '105',
                sts: '1',
                stsChngDatetime: '2022-04-14 13:51:21'
              }
            ],
            menuBasicInfo: {
              menuNo: '10560107',
              menuNm: '玉造荘(公立学校共済組合施設）',
              menuNmKana: 'フリガナ',
              menuStartDatetime: '2004-04-01 00:00:00',
              menuEndDatetime: '2023-03-31 23:59:59',
              srvicDiv: 'A20',
              shopAreaDiv: '0',
              catchPhrase: '旅と温泉、やすらぎの宿',
              leadCopy:
                '都市型シティホテルから四季折々の情緒溢れる温泉旅館まで多種多様。ご利用しやすい料金で一人旅でもご家族でも安心。観光の拠点にもぜひご利用ください。温泉や郷土料理でやすらぎのひとときをお楽しみいただけます。',
              outsideSysCd: null,
              areaLrgClassCd: null,
              areaLrgClassNm: '東北',
              areaMidClassCd: 'miyagi',
              areaMidClassNm: '宮城県',
              areaSmlClassCd: 'naruko',
              areaSmlClassNm: '鳴子・古川・くりこま高原',
              catLrgClassCd: '101',
              catLrgClassNm: null,
              catMidClassCd: '203',
              catMidClassNm: null,
              catSmlClassCd: '305',
              catSmlClassNm: null,
              partnerId: null,
              partnerNm: null
            },
            dtlChrgTotal: {
              gnrlChrgTotal: 0,
              tieupChrgTotal: 5000,
              memberChrgTotal: 12500,
              boneSbsidChrgTotal: 3500,
              pointUse: 0,
              addChrg: 0,
              bathTax: 0,
              hotelTax: 0,
              dscntAmtTotal: 0,
              pstg: 0,
              escrtFee: 0,
              chngAmt: 0,
              oficeFee: 0,
              cancelAmtGross: 0,
              cancelAmtNet: 0,
              cancelAmt: 0,
              cafePointAmtTotal: 0,
              sbsidTotal: 0,
              totalAmt: 0,
              billAmtTotal: 0,
              approvalAmt: 0,
              approvalMemo: null,
              tieupCancelAmt: 0,
              cancelSbsidTotal: 0,
              addChrgBrdwnPstg: 0,
              addChrgBrdwnChrg: 0,
              lifeSpSbsidChrgTotal: null
            },
            stayAcptDtl: {
              resrvSts: '1',
              dstnc: 0,
              hope: 0,
              nightCnt: 1,
              roomCnt: 1,
              adultTotalHeadCnt: null,
              adultManHeadCnt: null,
              adultWomanHeadCnt: null,
              chldHeadCnt: null,
              chldaHeadCnt: null,
              chldbHeadCnt: null,
              chldcHeadCnt: null,
              chlddHeadCnt: null,
              chldeHeadCnt: null,
              chldfHeadCnt: null,
              vistrAdultTotalHeadCnt: null,
              vistrAdultManHeadCnt: null,
              vistrAdultWomanHeadCnt: null,
              vistrChldHeadCnt: null,
              vistrChldaHeadCnt: null,
              vistrChldbHeadCnt: null,
              vistrChldcHeadCnt: null,
              vistrChlddHeadCnt: null,
              vistrChldeHeadCnt: null,
              vistrChldfHeadCnt: null,
              chldInfo: null,
              homeDprtrDate: null,
              homeDprtrDateSecndHope: null,
              outsideResrvId: null,
              rfrncNo: null,
              rfrncNo2: null,
              rfrncNo3: null,
              subMenuNm: null,
              useNum: null,
              fileSubmtInfoCorpNm: null,
              fileSubmtInfoYmd: null,
              fileSubmtInfoSeq: null,
              slepShrigHeadCnt: null,
              minorStayFlag: null,
              guardAgreeFlag: null,
              lastCheckInTm: null,
              checkOutTm: null,
              priceRemarks: null,
              breakfastFlag: null,
              dinnerFlag: null,
              parentMemberAccompanyFlag: null,
              readOnlyFlag: null,
              usageGuideReceiptDiv: '0',
              usageGuideReceiptFax: null
            },
            stayResrvRpsntInfo: {
              resrvFamilyNmKana: null,
              resrvFirstNmKana: null,
              rpsntFamilyNm: 'タナカ',
              rpsntFirstNm: 'ハナコ',
              rpsntFamilyNmKana: null,
              rpsntFirstNmKana: null,
              rpsntBirthday: null,
              rpsntSex: null,
              rpsntEmail: null,
              rpsntTel: null,
              rpsntZipCd: null,
              rpsntPrefectureCd: null,
              rpsntAddr1: null,
              rpsntAddr2: null,
              rpsntGen: null,
              rpsntRelationshipCd: null,
              rpsntVistrFlag: null,
              rpsntAge: null,
              note: null
            },
            sbsidRsvList: [],
            acptPrticPublicStayGetList: [
              {
                acptPrtic: {
                  acptPrticNo: 1,
                  gnrlChrg: 0,
                  tieupChrg: 16500,
                  memberChrg: 13000,
                  boneSbsidChrg: 3500,
                  cnt: 1,
                  dscntRatio: 0,
                  dscntAmt: 0,
                  escrtFee: 0,
                  tieupChrgSubtl: 16500,
                  memberChrgSubtl: 13000,
                  boneSbsidChrgSubtl: 3500,
                  escrtFeeSubtl: 0
                },
                stayPrtic: {
                  aloctRoom: '1',
                  roomId: '9999999999',
                  roomNm: null,
                  roomChrgFlag: '0',
                  chldaEscrtFeeFlag: '0',
                  chldbEscrtFeeFlag: '0',
                  chldcEscrtFeeFlag: '0',
                  chlddEscrtFeeFlag: '0',
                  chldeEscrtFeeFlag: '0',
                  chldfEscrtFeeFlag: '0'
                },
                stayRoomDayPrticList: [
                  {
                    aloctRoom: '1',
                    roomId: '9999999999',
                    stayDay: '2022-04-14',
                    adultTotalHeadCnt: 1,
                    adultManHeadCnt: 1,
                    adultWomanHeadCnt: 0,
                    chldHeadCnt: 4,
                    chldaHeadCnt: 2,
                    chldbHeadCnt: 2,
                    chldcHeadCnt: 0,
                    chlddHeadCnt: 0,
                    chldeHeadCnt: 0,
                    chldfHeadCnt: 0,
                    vistrAdultTotalHeadCnt: 2,
                    vistrAdultManHeadCnt: 2,
                    vistrAdultWomanHeadCnt: 0,
                    vistrChldHeadCnt: 3,
                    vistrChldaHeadCnt: 3,
                    vistrChldbHeadCnt: 0,
                    vistrChldcHeadCnt: 0,
                    vistrChlddHeadCnt: 0,
                    vistrChldeHeadCnt: 0,
                    vistrChldfHeadCnt: 0,
                    vistrFlag: '0',
                    sglUseFlag: '0',
                    slepShrigFlag: '0',
                    getNumNmChrg: 0,
                    adult1useChldChrgDiv: null,
                    roomMemberChrg: 0,
                    adultMemberChrg: 3000,
                    chldaMemberChrg: 2000,
                    chldbMemberChrg: 3000,
                    chldcMemberChrg: 0,
                    chlddMemberChrg: 0,
                    chldeMemberChrg: 0,
                    chldfMemberChrg: 0,
                    roomBoneSbsidChrg: 0,
                    adultBoneSbsidChrg: 2500,
                    chldaBoneSbsidChrg: 500,
                    chldbBoneSbsidChrg: 0,
                    chldcBoneSbsidChrg: 0,
                    chlddBoneSbsidChrg: 0,
                    chldeBoneSbsidChrg: 0,
                    chldfBoneSbsidChrg: 0,
                    roomEscrtFee: 0,
                    adultEscrtFee: 0,
                    chldaEscrtFee: 0,
                    chldbEscrtFee: 0,
                    chldcEscrtFee: 0,
                    chlddEscrtFee: 0,
                    chldeEscrtFee: 0,
                    chldfEscrtFee: 0,
                    roomMemberChrgSubtl: 0,
                    adultMemberChrgSubtl: 3000,
                    chldaMemberChrgSubtl: 4000,
                    chldbMemberChrgSubtl: 6000,
                    chldcMemberChrgSubtl: 0,
                    chlddMemberChrgSubtl: 0,
                    chldeMemberChrgSubtl: 0,
                    chldfMemberChrgSubtl: 0,
                    roomBoneSbsidChrgSubtl: 0,
                    adultBoneSbsidChrgSubtl: 2500,
                    chldaBoneSbsidChrgSubtl: 1000,
                    chldbBoneSbsidChrgSubtl: 0,
                    chldcBoneSbsidChrgSubtl: 0,
                    chlddBoneSbsidChrgSubtl: 0,
                    chldeBoneSbsidChrgSubtl: 0,
                    chldfBoneSbsidChrgSubtl: 0,
                    roomEscrtFeeSubtl: 0,
                    adultEscrtFeeSubtl: 0,
                    chldaEscrtFeeSubtl: 0,
                    chldbEscrtFeeSubtl: 0,
                    chldcEscrtFeeSubtl: 0,
                    chlddEscrtFeeSubtl: 0,
                    chldeEscrtFeeSubtl: 0,
                    chldfEscrtFeeSubtl: 0
                  }
                ]
              }
            ]
          }
        ]
      }
    }
    return new Promise((resolve, reject) => {
      axios.get(`/orders/${acptNo}/public-stay`).then(
        (res) => {
          // resolve(mockData)
          resolve(res.data)
        },
        (error) => {
          // resolve(mockData)
          reject(error?.error)
        }
      )
    })
  },
  postOstiariesNewTransaction() {
    const data = {
      data: {
        code: 1
      },
      command: 'NewTransaction',
      version: '2.0',
      timestamp: '2021-11-16T11:12:58.120+09:00',
      response: 'failure',
      customerNumber: '0363842506',
      error: {
        code: 200,
        message: 'Remote address is not acceptable.'
      },
      isError: true,
      // result: null
      result: {
        transactionId: '34392751-4212-4889-b220-4bb4738a89c8',
        createdAt: '2021-10-18T10:35:57.897+09:00',
        expiresAt: '2021-10-18T10:35:57.897+09:00',
        authenticNumber: '0800000000'
      }
    }
    return new Promise((resolve, reject) => {
      axios.post(`/ostiaries/new_transaction`).then(
        (response) => {
          resolve(data)
        },
        (error) => {
          resolve(data)
        }
      )
    })
  },
  getCafeInfo() {
    return cafeMockData.getCafeInfo();
  },
  checkCafeInfo() {
    return cafeMockData.checkCafeInfo();
  },
  
  getOrderHistory(params) {
    return new Promise((resolve, reject) => {
      resolve(
        {"cnts":0,"orderInfoList":[]}
      );
    });
  },
}

const cafeMockData = {
  getCafeInfo() {
    return {
      data: {
        cafeReservation: {
          cafeSubscriptionId: "12345",
          cafeMenuNo: "C0001",
          cafeMenuBranchNo: "1",
          pointRate: "1",
          rounding: "01",
          applyUnit: "",
          applyValue: "",
          cafeApplyNo: "11"
        },

        cafeMenuInfo: [
          {
            selected: true,
            cafeSubscriptionId: "12345",
            cafeCategoryNo: "1201",
            cafeCategoryNm: "カテゴリA",
            cafeMenuNo: "C0001",
            cafeMenuBranchNo: "1",
            cafeMenuNm: "テストカフェメニュー１",
            memberAccompany: false,
            targetUsers: {
              restriction: "2",
              detail: "両親"
            },
            pointUnit: {
              restriction: true,
              detail: 500
            },
            fixedPoint: {
              restriction: false,
              detail: ""
            },
            userCount: false,
            dayCount: false,
            proxyApp: false,
            applicationComment: {
              commentJp: "利用対象者は2親等までです",
              commentEn: "The target audience is up to 2nd degree."
            },
            availablePoint: "12000",
            pointRate: "1",
            rounding: "01",
            upperLimitPoint: "33333",
            upperLimitAmount: "55555"
          },
          {
            selected: false,
            cafeSubscriptionId: "67890",
            cafeCategoryNo: "1202",
            cafeCategoryNm: "カテゴリB",
            cafeMenuNo: "C0002",
            cafeMenuBranchNo: "1",
            cafeMenuNm: "テストカフェメニュー２",
            memberAccompany: false,
            targetUsers: {
              restriction: "2",
              detail: "兄弟"
            },
            pointUnit: {
              restriction: true,
              detail: 300
            },
            fixedPoint: {
              restriction: false,
              detail: ""
            },
            userCount: false,
            dayCount: false,
            proxyApp: false,
            applicationComment: {
              commentJp: "利用対象者は3親等までです",
              commentEn: "The target audience is up to 3nd degree."
            },
            availablePoint: "16000",
            pointRate: "1.5",
            rounding: "01",
            upperLimitPoint: "44444",
            upperLimitAmount: "66666"
          }
        ]
      }
    };
  },

  async orderInput(params) {
    return new Promise((resolve, reject) => {
      axios.post(`/order/order_input`, params).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
  async selectPay(params) {
    return new Promise((resolve, reject) => {
      axios.post(`/order/confirm/select_pay`, params).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
  async orderPay(reserveId, data) {
    const headers = {
      reserveId
    }
    return new Promise((resolve, reject) => {
      axios.post(`/order/order_pay`, data, {headers}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
};

